
import {AutogenLayoutUpdateCredentialsDialog} from "./autogen/AutogenLayoutUpdateCredentialsDialog";

export class UpdateCredentialsDialog extends AutogenLayoutUpdateCredentialsDialog {

}
